import ApplicationV1Adapter from 'uplisting-frontend/adapters/application-v1';

export default class BookingDotComLinkAdapter extends ApplicationV1Adapter {
  reconcileRatePlan(id: string, rateId?: string): Promise<object> {
    const url = `${this.buildURL('booking-dot-com-link', id)}/reconcile_rate_plan`;
    const data = rateId ? { rate_id: rateId } : {};

    return this.ajax(url, 'POST', { data }) as Promise<object>;
  }

  unlink(id: string): Promise<object> {
    return this.ajax(
      this.buildURL('booking-dot-com-link', id),
      'DELETE',
    ) as Promise<object>;
  }
}

declare module 'ember-data/types/registries/adapter' {
  export default interface AdapterRegistry {
    'booking-dot-com-link': BookingDotComLinkAdapter;
  }
}
